export type RecommendationClickPayload = {
    video_id: number;
    page_number: number;
    item_position: number;
    recommendation_id?: string;
    keyword?: string;
    country_code?: string;
    orientation?: string;
    logged_in?: boolean;
};

export const sendRecommendationClick = (payload: RecommendationClickPayload) => {
    fetch('/api/recommendations/click', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};

export type RecommendationScenario = 'home_page';

export type SendRecommendationImpressionPayload = {
    recommendation_id: string;
    scenario: RecommendationScenario;
};

export const trackRecommendationImpression = (payload: SendRecommendationImpressionPayload) => {
    fetch('/api/recommendations/track-impression', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
};
